/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';
import { Redirect, type Routes } from 'react-resource-router';
import { Home } from '@atlassian/twg-microsite-experience';

const homeRoute = {
	name: 'HOME',
	path: '/',
	exact: true,
	component: Home,
} as const;

const catchAllRoute = {
	name: 'not-found-redirect',
	path: '*', // Matches anything not caught above
	component: () => <Redirect to="/" />, // Redirect to home
};

export const routes: Routes = [homeRoute, catchAllRoute] as const;
